export default "__VITE_ASSET__DH9EWw3m__"